// extracted by mini-css-extract-plugin
module.exports = {"idio50m":"idio50m","p1oueogb":"p1oueogb","d11dou49":"d11dou49"};